import React from 'react';
import classes from './Square.css';

const square = (props) => {
    return (
        <div className = {classes.square} data-id = {props.id}></div> 
    )
}

export default square;


// WEBPACK FOOTER //
// ./src/components/Square/Square.js